import React, { useState, useRef } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import expandArrow from '../assets/icons/expand-arrow.svg';

interface MembershipDatePickerProps {
  label?: string;
  onChange: (date: Date) => void;
  value?: Date;
  isError?: boolean;
  errorText?: string;
  format?: string;
  disabled?: boolean;
}

const MembershipDatePicker: React.FC<MembershipDatePickerProps> = ({
  label,
  onChange,
  value,
  isError,
  errorText,
  format = 'DD-MM-YYYY',
  disabled = false,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const dateRef = useRef<HTMLDivElement>(null);

  const today = new Date();
  let selectedDate;

  if (value) {
    if (typeof value === 'string') {
      let momentDate = moment(value, moment.ISO_8601);
      
      if (!momentDate.isValid()) {
        momentDate = moment(value, format, true);
      }
      
      selectedDate = momentDate.isValid() ? momentDate.toDate() : today;
    } else {
      selectedDate = value;
    }
  } else {
    selectedDate = today;
  }

  const formatDate = (date: Date | string): string => {
    if (typeof date === 'string') {

      const [day, month, year] = date.split('-').map(Number);
      const parsedDate = new Date(year, month - 1, day);
      return moment(parsedDate).format(format);
    }
    return moment(date).format(format);
  };

  const handleDateChange = (date: Date) => {
    onChange(moment(date).utc(true).toDate());
    setIsCalendarOpen(false);
  };

  const toggleCalendar = () => {
    if(disabled) return;
    setIsCalendarOpen(!isCalendarOpen);
  };

  return (
    <div className="membership-date-container">
      <div className="membership-date-label">{label}</div>
      <div
        className={`membership-date-picker ${isError ? 'error' : ''}`}
        ref={dateRef}
      >
        <div
          className="membership-date-display"
          onClick={toggleCalendar}
        >
          <span>
            {value
              ? (formatDate(value) === moment(today).format(format)
                ? 'Today'
                : formatDate(value))
              : 'Today'}
          </span>
          <img src={expandArrow} alt="Expand calendar" className="membership-date-arrow" />
        </div>

        {isCalendarOpen && (
          <div className="membership-calendar-wrapper">
            <Calendar
              onChange={handleDateChange}
              value={selectedDate}
              className="membership-calendar"
              minDate={today}
            />
          </div>
        )}
      </div>
      {isError && errorText && <div className="membership-date-error">{errorText}</div>}
    </div>
  );
};

export default MembershipDatePicker;
